import { Autocomplete, TextField } from "@mui/material";
import axios from "axios";
import React, { useState, useEffect } from "react";
import { CSVLink } from "react-csv";
import { GrDocumentCsv } from "react-icons/gr";
import Loader from "../components/Loader";
import { PaginatedItems } from "../components/Paginated";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { toast } from "react-toastify";
import { localServer } from "../Path/Path";
import moment from "moment/moment";
import { withRouter } from "../components/withRouter";
import { formatItem } from "./common/FormatItems";

const POScannedItems = () => {
  const [responseData, setResponseData] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalDocuments, setTotalDocuments] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [loading, setLoading] = useState(false);
  const [toDate, setToDate] = useState(null);
  const [fromDate, setFromDate] = useState(null);
  const [poNumber, setPoNumber] = useState("");
  const [user, setUser] = useState("");
  const [siteId, setSiteId] = useState("");
  const [cartonNumber, setCartonNumber] = useState("");
  const [paginationData, setPaginationData] = useState({});
  const [csvData, setCsvData] = useState([]);

  const validateDate = (date) => {
    const dateFormat = "MM/DD/YYYY";
    if (!date) {
      return true;
    }
    if (!moment(date, dateFormat, true).isValid()) {
      return false;
    }
    if (moment(date).isAfter(moment())) {
      return false;
    }
    return true;
  };

  const getPOScannedItems = async (pageNumber = 1) => {
    const newFromDate = validateDate(fromDate);
    const newToDate = validateDate(toDate);
    if (!newFromDate || !newToDate) {
      toast.error("Please enter valid date ranges.");
      return;
    }

    setLoading(true);
    try {
      const params = {
        pageNo: pageNumber,
        poNumber: poNumber,
        user: user,
        siteId: siteId,
        cartonNumber: cartonNumber,
        startDate: fromDate
          ? moment(fromDate).startOf("day").format("YYYY-MM-DD")
          : "",
        endDate: toDate ? moment(toDate).endOf("day").format("YYYY-MM-DD") : "",
      };

      const response = await axios.get(`${localServer}store/po-scanned-items`, {
        params,
      });

      if (response.data && response.data.data) {
        setResponseData(response.data.data.data);
        setPaginationData(response.data.data.pagination);
        setTotalDocuments(response.data.data.pagination.totalItems);

        if (response.data.data.data.length === 0) {
          toast.error("No data found.");
        } else {
          setCurrentPage(response.data.data.pagination.currentPage);
          setItemsPerPage(response.data.data.pagination.itemsPerPage);
        }
      } else {
        console.error("Unexpected API response structure:", response.data);
      }
    } catch (err) {
      toast.error("Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  const getCSV = async () => {
    const newFromDate = validateDate(fromDate);
    const newToDate = validateDate(toDate);
    if (!newFromDate || !newToDate) {
      toast.error("Please enter valid date ranges.");
      return;
    }

    setLoading(true);
    try {
      const params = {
        poNumber: poNumber,
        user: user,
        siteId: siteId,
        cartonNumber: cartonNumber,
        startDate: fromDate
          ? moment(fromDate).startOf("day").format("YYYY-MM-DD")
          : "",
        endDate: toDate ? moment(toDate).endOf("day").format("YYYY-MM-DD") : "",
      };

      const response = await axios.get(`${localServer}store/po-scanned-items/csv`, {
        params,
        responseType: "blob",
      });

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "POScannedItemsReport.csv");
      document.body.appendChild(link);

      link.click();
      link.parentNode.removeChild(link);
    } catch (error) {
      console.error("Error downloading the file:", error);
    }
    setLoading(false);
  };

  useEffect(() => {
    getPOScannedItems();
  }, []);

  const headers = [
    "Scanned At",
    "PO Number",
    "EPC",
    "Barcode",
    "Carton Number",
    "User",
    "Site ID",
  ];

  const colNames = [
    "scannedAt",
    "poNumber",
    "epc",
    "barcode",
    "cartonNumber",
    "user",
    "siteId",
  ];

  const startItem = currentPage ? (currentPage - 1) * itemsPerPage + 1 : 0;
  const endItem = currentPage
    ? Math.min(currentPage * itemsPerPage, totalDocuments)
    : 0;

  return (
    <React.Fragment>
      <Loader loading={loading} />
      <div className="dashboard-main">
        <div
          className="dashboard-top"
          style={{
            display: "flex",
            flexDirection: "column",
            padding: "10px",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <div
              style={{
                flex: "1",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <p
                className="stock-count"
                style={{ fontSize: "25px", margin: 0 }}
              >
                PO Scanned Items Report
              </p>
            </div>
            <GrDocumentCsv
              onClick={getCSV}
              color="black"
              fontSize={25}
              style={{ marginRight: 5, cursor: "pointer" }}
            />
          </div>
          <div>
            <h1 style={{ color: "black", fontSize: "15px" }}>
              {new Date().toLocaleString("hi-IN")}
            </h1>
          </div>
        </div>
        <div className="dashboard-bottom" style={{ marginTop: "0.5%" }}>
          <div
            style={{
              display: "flex",
              width: "100%",
              gridColumnGap: "20px",
              justifyContent: "space-between",
              flexWrap: "wrap",
            }}
          >
            <div
              style={{
                display: "flex",
                gridColumnGap: "10px",
                gridRowGap: "10px",
                flexWrap: "wrap",
              }}
            >
              <DesktopDatePicker
                label="From Date"
                clearable
                showTodayButton
                inputFormat="MM/DD/YYYY"
                size={"small"}
                maxDate={new Date()}
                value={fromDate}
                onChange={(data) => setFromDate(data)}
                componentsProps={{
                  actionBar: {
                    actions: ["clear"],
                  },
                }}
                renderInput={(params) => (
                  <TextField sx={{ width: 170 }} size={"small"} {...params} />
                )}
              />
              <DesktopDatePicker
                label="To Date"
                clearable
                showTodayButton
                inputFormat="MM/DD/YYYY"
                size={"small"}
                maxDate={new Date()}
                value={toDate}
                onChange={(data) => setToDate(data)}
                componentsProps={{
                  actionBar: {
                    actions: ["clear"],
                  },
                }}
                renderInput={(params) => (
                  <TextField sx={{ width: 170 }} size={"small"} {...params} />
                )}
              />
              <TextField
                label="PO Number"
                size="small"
                sx={{ width: 170 }}
                value={poNumber}
                onChange={(e) => setPoNumber(e.target.value)}
              />
              <TextField
                label="User"
                size="small"
                sx={{ width: 170 }}
                value={user}
                onChange={(e) => setUser(e.target.value)}
              />
              <TextField
                label="Site ID"
                size="small"
                sx={{ width: 170 }}
                value={siteId}
                onChange={(e) => setSiteId(e.target.value)}
              />
              <TextField
                label="Carton Number"
                size="small"
                sx={{ width: 170 }}
                value={cartonNumber}
                onChange={(e) => setCartonNumber(e.target.value)}
              />
            </div>
            <button onClick={() => getPOScannedItems()} className="run-btn">
              <p className="run-text">Search</p>
            </button>
          </div>

          <div
            style={{
              marginTop: "10px",
              overflowX: "scroll",
              height: "600px",
            }}
          >
            <PaginatedItems
              pageCountNew={paginationData?.totalPages || 0}
              getData={(pageNumber) => getPOScannedItems(pageNumber)}
              totalLength={totalDocuments}
              headers={headers}
              colNames={colNames}
              forcePage={paginationData?.currentPage - 1 || 0}
              itemsPerPage={itemsPerPage}
              data={responseData.map((item) => ({
                ...formatItem(item),
                scannedAt: moment.utc(item.updatedAt || item.createdAt).local().format(
                  "MM/DD/YYYY hh:mm:ss A"
                ),
              }))}
            />
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginTop: "10px",
              color: "white",
              padding: "10px",
              gap: "10px",
            }}
          >
            <h5>ROWS PER PAGE: {itemsPerPage}</h5>
            <h5>{`${startItem}-${endItem} of ${totalDocuments}`}</h5>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default withRouter(POScannedItems);
